import { render, staticRenderFns } from "./SeriesQuestions.vue?vue&type=template&id=4610bca9&"
import script from "./SeriesQuestions.vue?vue&type=script&lang=js&"
export * from "./SeriesQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports